<template>
    <div class="btn-group btn-group-toggle">
        <btn v-for="option in options" class="btn btn-outline-light"
             :class="{'active': (typeof option === 'object' && value === option.value) || value === option}"
             @click="selectOption(option)">
            {{ typeof option === 'object' ? option.label : option }}
        </btn>
    </div>
</template>

<script>

export default {
    name: 'BtnGroupToggle',
    props: {
        options: {
            default: [],
        },
        value: {
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {
        selectOption(option) {
            if (typeof option === 'object') {
                if (option.value === this.value) {
                   //TODO deselect value
                } else {
                    this.$emit('input', option.value);
                }
            } else {
                this.$emit('input', option);
            }
        },
    },
};
</script>
